<iframe
  class="landing-earn-dialog-frame"
  width="100%"
  height="100%"
  [src]="earnEmbeddedUrl | safeURL"
  title="YouTube video player"
  frameborder="0"
  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
  allowfullscreen
></iframe>
